import { Mark } from '@tiptap/core'

const Typed = Mark.create({
  name: 'typed',

  addOptions () {
    return {
      words: [''],
      speed: [],
      backspeed: [],
      fade: []
    }
  },

  addAttributes () {
    return {
      words: {
        default: '',
        parseHTML: element => element.getAttribute('words') || '',
        renderHTML: attrs => (attrs.words ? { words: attrs.words } : {})
      },
      speed: {
        default: '',
        parseHTML: element => element.getAttribute('speed') || '',
        renderHTML: attrs => (attrs.speed ? { speed: attrs.speed } : {})
      },
      backspeed: {
        default: '',
        parseHTML: element => element.getAttribute('backspeed') || '',
        renderHTML: attrs => (attrs.backspeed ? { backspeed: attrs.backspeed } : {})
      },
      fade: {
        default: '',
        parseHTML: element => element.getAttribute('fade') || '',
        renderHTML: attrs => (attrs.fade ? { fade: attrs.fade } : {})
      }
    }
  },

  parseHTML () {
    return [
      {
        tag: 'typed'
      }
    ]
  },

  renderHTML ({ HTMLAttributes }) {
    return ['typed', HTMLAttributes, 0]
  },

  addCommands () {
    return {
      typed: attrs => ({ commands }) => {
        if (!attrs) {
          return commands.unsetMark(this.name)
        }

        return commands.setMark(this.name, attrs)
      }
    }
  }
})

export default Typed
